function httpBodyToText(data: unknown): string {
  if (typeof data === 'string') return data;
  if (data == null) return '';
  if (typeof data === 'object') return JSON.stringify(data);
  return String(data);
}

/** Capacitor ネイティブは capacitor:// 起点のため fetch が CORS で失敗する。ネイティブ HTTP で取得する。 */
export async function fetchImportFile(url: string): Promise<{ ok: boolean; status: number; text: string }> {
  try {
    const { Capacitor, CapacitorHttp } = await import('@capacitor/core');
    if (Capacitor.isNativePlatform()) {
      const response = await CapacitorHttp.get({ url, responseType: 'text' });
      const status = response.status ?? 0;
      const text = httpBodyToText(response.data);
      return { ok: status >= 200 && status < 300, status, text };
    }
  } catch {
    // Web / Electron
  }

  const response = await fetch(url);
  return { ok: response.ok, status: response.status, text: await response.text() };
}
